import React from 'react'

import Head from '../head'
import { Link, Title, Image } from '@cms/ui'
import { cleanUrl } from '@cms/utils'

const AboutPage = ({
  data: { title, description: desc, zh_intro, en_intro, avatar },
}) => {
  return (
    <div className="row about-page">
      <Head title={title} desc={desc} />
      <div className="column">
        <Title>{title}</Title>
        <div className="row">
          <div className="column left-column" />
          <div className="column">
            <div className="zh-name">{'​陳鈞樂'}</div>
            <div className="en-name">{'CHAN KWAN LOK'}</div>
          </div>
        </div>
        <div className="row">
          <div className="column left-column">
            <div className="profile">
              <Image
                src={cleanUrl(
                  `${process.env.NEXT_STRAPI_PUBLIC_ENDPOINT}/${avatar.responsiveImages.urlPrefix}`
                )}
                placeholder={avatar.responsiveImages.placeholder}
                ratio={1}
                alt="Picture of the author"
                sizes="300px"
              />
            </div>
          </div>
          <div className="column">
            <p>{zh_intro}</p>
            <p>{en_intro}</p>
            <Link href="/exhibitions" className="link">
              Full Exhibitions
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export async function getStaticProps({ preview = false }) {
  const { fetchSingluarType } = await import('../data')
  const data = await fetchSingluarType('about-page', ['avatar'])

  return {
    props: {
      preview,
      data,
    },
  }
}

export default AboutPage
